module.exports = __webpack_public_path__ + "static/media/Union1.3e60ef77.svg";